export enum PopinType {
	Success = 1,
	Error = 2,
	Warning = 3,
	Info = 4,
	None = -1
}